import { actions } from './actions'

const initialState = {
  diasEspeciales: {
    data: [],
    loading: false,
    error: '',
  },
  diasEspecialesEditar: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  diaEspecial: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function diasEspecialesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.DIAS_ESPECIALES_LOAD_REQUESTED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: true },
      }
    case actions.DIAS_ESPECIALES_LOAD_SUCCEEDED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, data: action.payload, loading: false },
      }
    case actions.DIAS_ESPECIALES_LOAD_FILED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: false, error: action.error },
      }
    case actions.DIA_ESPECIAL_UPDATE_REQUESTED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: true, error: '' },
      }
    case actions.DIA_ESPECIAL_UPDATE_SUCCEEDED:
      return {
        ...state,
        diasEspeciales: {
          ...state.diasEspeciales,
          data: state.diasEspeciales.data.map(dia =>
            dia.id === action.payload.id ? action.payload : dia,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.DIA_ESPECIAL_UPDATE_FILED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: false, error: action.error },
      }
    case actions.DIA_ESPECIAL_DELETE_REQUESTED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: true, error: '' },
      }
    case actions.DIA_ESPECIAL_DELETE_SUCCEEDED:
      return {
        ...state,
        diasEspeciales: {
          ...state.diasEspeciales,
          data: state.diasEspeciales.data.filter(dia => dia.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.DIA_ESPECIAL_DELETE_FILED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: false, error: action.error },
      }
    case actions.DIA_ESPECIAL_INSERT_REQUESTED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: true, error: '' },
      }
    case actions.DIA_ESPECIAL_INSERT_SUCCEEDED:
      return {
        ...state,
        diasEspeciales: {
          ...state.diasEspeciales,
          data: [].concat(action.payload, state.diasEspeciales.data),
          loading: false,
          error: '',
        },
      }
    case actions.DIA_ESPECIAL_INSERT_FILED:
      return {
        ...state,
        diasEspeciales: { ...state.diasEspeciales, loading: false, error: action.error },
      }
    case actions.DIAS_ESPECIALES_EDITAR_LOAD_REQUESTED:
      return {
        ...state,
        diasEspecialesEditar: { ...state.diasEspecialesEditar, loading: true },
      }
    case actions.DIAS_ESPECIALES_EDITAR_LOAD_SUCCEEDED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.DIAS_ESPECIALES_EDITAR_LOAD_FILED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          loading: false,
          error: action.error,
        },
      }
    case actions.DIA_ESPECIAL_EDITAR_DELETE_REQUESTED:
      return {
        ...state,
        diasEspecialesEditar: { ...state.diasEspecialesEditar, loading: true, error: '' },
      }
    case actions.DIA_ESPECIAL_EDITAR_DELETE_SUCCEEDED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          data: state.diasEspecialesEditar.data.map(dia => ({
            ...dia,
            horarioEntregaDeleted:
              dia.horarioEntregaId === action.payload.id
                ? action.payload.delete
                : dia.horarioEntregaDeleted,
          })),
          loading: false,
          error: '',
        },
      }
    case actions.DIA_ESPECIAL_EDITAR_DELETE_FILED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          loading: false,
          error: action.error,
        },
      }
    case actions.DIA_ESPECIAL_EDITAR_INSERT_REQUESTED:
      return {
        ...state,
        diasEspecialesEditar: { ...state.diasEspecialesEditar, loading: true, error: '' },
      }
    case actions.DIA_ESPECIAL_EDITAR_INSERT_SUCCEEDED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          loading: false,
          error: '',
          reload: true,
        },
      }
    case actions.DIA_ESPECIAL_EDITAR_INSERT_FILED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          loading: false,
          error: action.error,
        },
      }
    case actions.DIA_ESPECIAL_BY_ID_LOAD_REQUESTED:
      return {
        ...state,
        diaEspecial: { ...state.diaEspecial, loading: true },
      }
    case actions.DIA_ESPECIAL_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        diaEspecial: { ...state.diaEspecial, data: action.payload, loading: false },
      }
    case actions.DIA_ESPECIAL_BY_ID_LOAD_FILED:
      return {
        ...state,
        diaEspecial: { ...state.diaEspecial, loading: false, error: action.error },
      }

    case actions.DIA_ESPECIAL_EDITAR_UPDATE_REQUESTED:
      return {
        ...state,
        diasEspecialesEditar: { ...state.diasEspecialesEditar, loading: true, error: '' },
      }
    case actions.DIA_ESPECIAL_EDITAR_UPDATE_SUCCEEDED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          loading: false,
          error: '',
          reload: true,
        },
      }
    case actions.DIA_ESPECIAL_EDITAR_UPDATE_FILED:
      return {
        ...state,
        diasEspecialesEditar: {
          ...state.diasEspecialesEditar,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
